export default {
  layout: {
    tabEvents: "Wirtschaftliche Ereignisse",
    eventsDescription:
      "Wirtschaftliche Ereignisse und Ledger-Zuordnungsschnappschüsse",
    tabExternal: "Externe Zahlungen",
    externalDescription: "Externe PSP-Zahlungen",
    tabSettlements: "Abrechnungen",
    settlementsDescription: "Offene Abrechnungspositionen nach Empfänger",
  },
  shared: {
    emptyCell: "—",
    colCreated: "Erstellt",
    colType: "Typ",
    colStatus: "Status",
    colAmount: "Betrag",
  },
  eventsList: {
    loadError: "Wirtschaftliche Ereignisse konnten nicht geladen werden",
    colGross: "Brutto",
    colMethod: "Methode",
    colLines: "Zeilen",
    colExternalPayment: "Zahlung",
    openRowAria: "Ereignis {{id}} öffnen",
    eventType: {
      CHECKOUT_CAPTURED: "Checkout",
      BOOKING_PAYMENT_CAPTURED: "Buchungszahlung",
      SELLER_FEE_FROM_RECEIPT: "Beleggebühr",
      REFUND_REVERSAL: "Rückerstattungsstorno",
      SELLER_BANK_TRANSFER_SENT: "Überweisung gesendet",
      SELLER_BANK_TRANSFER_RECEIVED: "Überweisung empfangen",
    },
    eventStatus: {
      DRAFT: "Entwurf",
      POSTED: "Gebucht",
      REVERSED: "Storniert",
    },
    allocationMethod: {
      USER_PAYMENT: "Benutzerzahlung",
      SELLER_FEE: "Verkäufergebühr",
      REFUND: "Rückerstattung",
      TREASURY_SETTLEMENT: "Treasury-Abrechnung",
    },
  },
  externalList: {
    statusAll: "Alle Status",
    openRowAria: "Zahlung {{id}} anzeigen",
    loadError: "Externe Zahlungen konnten nicht geladen werden",
    statusCountsLoadError: "Anzahl pro Status konnte nicht geladen werden",
    linkedPayment: "Verknüpfte Zahlung",
    clearHighlight: "Hervorhebung aufheben",
    selectedPayment: "Ausgewählte Zahlung",
    providerFlow: "Anbieter / Ablauf",
    providerPaymentId: "Anbieter-Zahlungs-ID",
    idempotencyKey: "Idempotenzschlüssel",
    booking: "Buchung",
    paymentId: "Zahlungs-ID",
    colProviderRef: "Anbieter-Ref.",
    colBooking: "Buchung",
    colPaymentId: "Zahlungs-ID",
    paymentStatus: {
      CREATED: "Erstellt",
      AUTHORIZED: "Autorisiert",
      CAPTURED: "Erfasst",
      FAILED: "Fehlgeschlagen",
      CANCELED: "Storniert",
      REFUNDED: "Erstattet",
      REFUND_FAILED: "Erstattung fehlgeschlagen",
      PENDING: "Ausstehend",
      AWAITING_APP: "Wartet auf App",
      PENDING_RECONCILIATION: "Abgleich ausstehend",
      COMPLETED: "Abgeschlossen",
      REVERTED: "Rückgängig gemacht",
    },
    paymentType: {
      CHECKOUT_PAYMENT: "Checkout-Zahlung",
      SELLER_PAYOUT: "Verkäufer-Auszahlung",
    },
    provider: {
      SUMUP: "SumUp",
      MOCK: "Mock",
      REVOLUT: "Revolut",
    },
    flow: {
      CLOUD_POS: "Cloud-POS",
      BANK_TRANSFER: "Banküberweisung",
    },
  },
  eventDetail: {
    splitAria: "Aufteilung nach Rolle",
    technicalTitle: "Technische Daten",
    technicalHint: "Snapshot der Aufteilungsregeln und Rohmetadaten",
    roles: {
      PROCESSOR_FEES: "Zahlungsgebühren",
      SELLER: "Verkäufer",
      HOST: "Host",
      SALES_AGENT_ACTIVITY: "Vertriebsagent (Aktivität)",
      SALES_AGENT_HOUSE: "Vertriebsagent (Haus)",
      PLATFORM: "Plattform",
      TREASURY_CLEARING: "Treasury-Clearing",
    },
    loadError: "Ereignis konnte nicht geladen werden",
    loading: "Ereignis wird geladen…",
    notFound: "Ereignis nicht gefunden.",
    backToEvents: "Zurück zu Ereignissen",
    allEvents: "Alle Ereignisse",
    viewExternalPayment: "Zahlung anzeigen",
    cardTitle: "Wirtschaftliches Ereignis",
    currency: "Währung",
    grossAmount: "Bruttobetrag",
    idempotencyKey: "Idempotenzschlüssel",
    ledgerEntries: "Ledger-Einträge",
    bookingId: "Buchungs-ID",
    checkoutId: "Checkout-ID",
    reversesEvent: "Storniert Ereignis",
    updated: "Aktualisiert",
    jsonAllocationSnapshot: "Zuordnungsregel-Schnappschuss",
    jsonMetadata: "Metadaten",
    jsonNone: "Keine",
    allocationLinesTitle: "Zuordnungszeilen",
    allocationLinesSubtitle:
      "Eingefrorener Schnappschuss im Ledger gebucht ({{count}} Zeilen)",
    colStep: "Schritt",
    colRole: "Rolle",
    colStoredPercent: "Gespeichert %",
    colAbsolutePercent: "Absolut %",
    colLedgerAccount: "Ledger-Konto",
    colLineId: "Zeilen-ID",
    noAllocationLines: "Keine Zuordnungszeilen",
  },
  settlements: {
    roles: {
      seller: "Verkäufer",
      host: "Host",
      salesAgent: "Vertriebsagent",
    },
    payees: {
      kpiPayeeCount_one: "{{count}} Empfänger",
      kpiPayeeCount_other: "{{count}} Empfänger",
      loadError: "Abrechnungsempfänger konnten nicht geladen werden",
      searchPlaceholder: "Name oder E-Mail",
      filterRole: "Rolle",
      filterAllRoles: "Alle Rollen",
      filterDefault: "Offen",
      filterToBePaid: "Zu zahlen",
      filterToBeInvoiced: "Zu fakturieren",
      colName: "Empfänger",
      colRole: "Rolle",
      colPayable: "Offene Forderung",
      colCommissionOpen: "Offene Provision",
      colSupplierOpen: "Lieferantenrechnung ausstehend",
      legalIncompleteTooltip: "Rechtliche Angaben unvollständig",
      openRowAria: "Empfänger {{name}} öffnen",
      amountWithCount: "{{amount}} ({{count}})",
      empty: "Keine Empfänger gefunden",
    },
    detail: {
      loadError: "Abrechnungszeilen konnten nicht geladen werden",
      loading: "Abrechnungszeilen werden geladen…",
      back: "Zurück zu Empfängern",
      linesTitle: "Abrechnungszeilen",
      linesSubtitle:
        "Wählen Sie die Zeilen, die die Workflow-Aktionen rechts steuern.",
      flowFilter: "Ablauf",
      paymentFilter: "Zahlung",
      invoiceFilter: "Rechnung",
      flowFilterAll: "Alle",
      flowFilterUpfront: "Vorauszahlungs-Aktivität",
      flowFilterReceiptBased: "Belegbasierte Aktivität",
      flowFilterOutgoingCommissions: "Ausgehende Provisionen",
      paymentFilterAll: "Alle",
      paymentFilterUnpaid: "Unbezahlt",
      paymentFilterPaid: "Bezahlt",
      paymentFilterUncollected: "Nicht eingezogen",
      paymentFilterCollected: "Eingezogen",
      invoiceFilterAll: "Alle",
      invoiceFilterUninvoiced: "Nicht fakturiert",
      invoiceFilterInvoiced: "Fakturiert",
      invoiceFilterPending: "Ausstehend",
      invoiceFilterReceived: "Empfangen",
      deselectAll: "Alle abwählen",
      emptyFiltered: "Keine Zeilen entsprechen den aktuellen Filtern",
      filteredCount: "Anzeige {{shown}} von {{total}} Zeilen",
      invoiceToInvoice: "Zu fakturieren",
      invoiceInvoiced: "Fakturiert",
      invoiceSummaryNotSent: "Zusammenfassung nicht gesendet",
      invoiceAwaitingInvoice: "Rechnung ausstehend",
      invoiceReceived: "Rechnung empfangen",
      paymentAwaiting: "Ausstehend",
      paymentReceived: "Empfangen",
      paymentToPay: "Zu zahlen",
      paymentPaid: "Bezahlt",
      paymentNotAvailable: "Nicht verfügbar",
      copyCollectionReference: "Einzugsreferenz kopieren",
      copyInvoiceReference: "Rechnungsreferenz kopieren",
      copyPaymentReference: "Zahlungsreferenz kopieren",
      actionsPanelTitle: "Aktionen",
      actionsPanelSubtitle:
        "Abrechnungsschritte für die ausgewählten Zeilen ausführen.",
      selectionSummaryTitle: "Auswahlübersicht",
      readOnlyHint: "Sie haben nur Lesezugriff auf diese Abrechnung.",
      finalizedReadOnlyHint:
        "Diese Abrechnung ist fakturiert und bezahlt — Felder sind schreibgeschützt.",
      noActionsHint: "Wählen Sie Zeilen, um verfügbare Aktionen zu sehen.",
      selectMetricPayable: "Offene Forderungszeilen auswählen",
      selectMetricInvoiceable: "Offene Provisionszeilen auswählen",
      selectMetricCollectible: "Zeilen zum Einzug auswählen",
      selectMetricSupplierInvoice:
        "Zeilen mit ausstehender Lieferantenrechnung auswählen",
      openPayable: "Offene Forderung",
      openInvoiceable: "Offene zu fakturierende Provision",
      openPendingSupplierInvoice: "Lieferantenrechnung ausstehend",
      openCollectible: "Offen zum Einzug",
      selectAll: "Alle auswählen",
      selectLine: "Zeile für {{activity}} auswählen",
      colEvent: "Ereignis",
      colInvoiceAmount: "Rechnungsbetrag",
      colInvoiceStatus: "Rechnungsstatus",
      moneyDirectionOutgoing: "Ausgehendes Geld",
      moneyDirectionIncoming: "Eingehendes Geld",
      colPaymentAmount: "Zahlungsbetrag",
      colPaymentStatus: "Zahlungsstatus",
      viewFePdf: "Ansehen",
      downloadFePdf: "Herunterladen",
      downloadFePdfError:
        "Provisionsrechnungs-PDF konnte nicht heruntergeladen werden",
      empty: "Keine Abrechnungszeilen",
      selectedPayable: "Ausgewählte Forderung",
      selectedInvoiceable: "Ausgewählte fakturierbare Beträge",
      selectedCount: "Ausgewählte Zeilen",
      markInvoiced: "Als fakturiert markieren",
      markPaid: "Als bezahlt markieren",
      invoiceNotePlaceholder: "Notiz für Provisionsrechnung (optional)",
      collectionNotePlaceholder: "Notiz für Einzug (optional)",
      supplierNotePlaceholder: "Notiz für Lieferantenrechnung (optional)",
      paymentNotePlaceholder: "Notiz für Auszahlung (optional)",
      referencePlaceholder: "Überweisungsreferenz",
      referenceRequired: "Zahlungsreferenz ist erforderlich",
      invoicedSuccess: "Ausgewählte Zeilen als fakturiert markiert",
      invoicedError: "Zeilen konnten nicht als fakturiert markiert werden",
      paidSuccess: "Ausgewählte Zeilen als bezahlt markiert",
      paidError: "Zeilen konnten nicht als bezahlt markiert werden",
      selectedCollectible: "Ausgewählt zum Einzug",
      viewSupplierInvoice: "Rechnung ansehen",
      downloadSupplierInvoice: "Rechnung herunterladen",
      downloadSupplierInvoiceError:
        "Lieferantenrechnung konnte nicht heruntergeladen werden",
      flowLabel: {
        UPFRONT: "Vorauszahlung",
        RECEIPT_BASED: "Belegbasierte Zahlung",
        SUPPLIER_PAYOUT: "Lieferantenauszahlung",
      },
      flowHint: {
        UPFRONT:
          "Geld bereits eingezogen: Provisionsrechnung ausstellen und Verkäufer bezahlen.",
        RECEIPT_BASED:
          "Proforma senden, Überweisung erfassen, dann Rechnung ausstellen.",
        SUPPLIER_PAYOUT:
          "Zusammenfassung senden, empfangene Rechnung erfassen, dann Verkäufer bezahlen.",
      },
      mixedSelectionWarning:
        "Ausgewählte Zeilen folgen unterschiedlichen Abrechnungs-Workflows. Schränken Sie die Auswahl auf einen Workflow ein, bevor Sie Aktionen ausführen.",
      emailNever: "Nie gesendet",
      emailLast: "Zuletzt gesendet {{when}}",
      emailSentCount: "{{count}}× gesendet",
      steps: {
        summaryTitle: "Zusammenfassung senden",
        summaryDesc:
          "Dem Verkäufer per E-Mail die Zusammenfassung der ausgewählten Transaktionen senden (PDF angehängt).",
        summaryButton: "Zusammenfassungs-E-Mail senden",
        summaryResend: "Zusammenfassung erneut senden",
        proformaTitle: "Proforma senden",
        proformaDesc:
          "Dem Verkäufer die Proforma für die ausgewählten Provisionszeilen per E-Mail senden, bevor der Einzug erfasst wird.",
        proformaButton: "Proforma-E-Mail senden",
        proformaResend: "Proforma erneut senden",
        summarySuccess: "Zusammenfassungs-E-Mail gesendet",
        summaryError: "Zusammenfassungs-E-Mail konnte nicht gesendet werden",
        summaryAllInvoiced: "Alle ausgewählten Zeilen sind bereits fakturiert",
        summarySkipped: "E-Mail nicht gesendet: {{detail}}",
        invoiceTitle: "Rechnung ausstellen",
        invoiceDesc:
          "Provisionsrechnung für die ausgewählten Zeilen ausstellen.",
        collectTitle: "Einzug erfassen",
        collectDesc:
          "Die vom Verkäufer für die ausgewählten Zeilen empfangene Zahlung erfassen.",
        collectButton: "Einzug erfassen",
        collectSuccess: "Einzug erfasst",
        collectError: "Einzug konnte nicht erfasst werden",
        collectReferencePlaceholder: "Referenz eingehender Überweisung",
        supplierTitle: "Empfangene Rechnung erfassen",
        supplierDesc:
          "Die vom Verkäufer ausgestellte Rechnung hochladen (ein PDF kann mehrere Zeilen abdecken).",
        supplierRegisteredDesc:
          "Für diese Auswahl ist bereits eine Lieferantenrechnung erfasst.",
        supplierRegisteredUntitled: "Erfasste Rechnung",
        supplierRegisteredAt: "Erfasst {{when}}",
        supplierReplaceDesc:
          "Laden Sie eine neue Datei hoch, um die erfasste Rechnung zu ersetzen.",
        supplierReplaceButton: "Rechnung ersetzen",
        supplierReplaceSubmit: "Ersatz speichern",
        supplierReplaceSuccess: "Lieferantenrechnung ersetzt",
        supplierReplaceError: "Lieferantenrechnung konnte nicht ersetzt werden",
        supplierButton: "Empfangene Rechnung erfassen",
        supplierNumberLabel: "Rechnungsnummer",
        supplierNumberPlaceholder: "z. B. 2026/123",
        supplierDateLabel: "Rechnungsdatum (optional)",
        supplierTotalLabel: "Gesamt €",
        supplierExpectedTotal:
          "Muss mit den ausgewählten Zeilen übereinstimmen: {{amount}}",
        supplierFileLabel: "Rechnungsdatei (PDF oder Bild)",
        supplierNumberRequired: "Geben Sie die Rechnungsnummer ein",
        supplierFileRequired: "Wählen Sie die Rechnungsdatei",
        supplierFileTooLarge: "Datei ist zu groß. Maximale Größe: {{max}}.",
        supplierFileUnsupported:
          "Bitte laden Sie ein Bild oder eine PDF-Rechnung hoch.",
        supplierTotalRequired: "Geben Sie den Rechnungsgesamtbetrag ein",
        supplierTotalInvalid:
          "Ungültiger Betrag (z. B. 1.234,56 oder 1.234,56)",
        supplierTotalMismatch:
          "Der Rechnungsbetrag muss mit den ausgewählten Zeilen übereinstimmen ({{expected}}).",
        supplierSuccess: "Lieferantenrechnung erfasst",
        supplierError: "Lieferantenrechnung konnte nicht erfasst werden",
        payTitle: "Zahlung ausführen",
        payDesc:
          "Verkäufer über Revolut bezahlen oder manuelle Zahlung erfassen.",
        unavailableTitle: "Schritt nicht bereit",
        unavailableGoBack: "Zurück",
        unavailableConfirm: "Trotzdem fortfahren",
        unavailableSummary: "Dieser Schritt ist immer verfügbar, wenn Zeilen ausgewählt sind.",
        unavailableCollect: "Die Zusammenfassungs-E-Mail wurde für nicht alle ausgewählten Zeilen gesendet. Trotzdem fortfahren?",
        unavailableSupplier: "Die Zusammenfassungs-E-Mail wurde für nicht alle ausgewählten Zeilen gesendet. Trotzdem fortfahren?",
        unavailableInvoice:
          "Frühere Schritte sind für nicht alle ausgewählten Zeilen abgeschlossen (Zusammenfassung, Einzug oder empfangene Rechnung). Trotzdem fortfahren?",
        unavailablePay:
          "Frühere Schritte sind für nicht alle ausgewählten Zeilen abgeschlossen (Zusammenfassung, Rechnung oder Einzug). Trotzdem fortfahren?",
      },
      revolut: {
        bannerTitle: "Revolut-Auszahlung läuft",
        status: "Status: {{status}}",
        referenceLabel: "Revolut-Zahlungsreferenz",
        payButton: "Mit Revolut bezahlen",
        referenceRequired:
          "Geben Sie eine Referenz für diese Revolut-Auszahlung ein",
        initiated: "Revolut-Auszahlung gestartet",
        completedToast:
          "Revolut-Auszahlung abgeschlossen — Zeilen aktualisiert",
        pendingReconciliationLabel:
          "Ledger-Abgleich ausstehend (Gelder in Revolut bewegt; automatische Wiederholungen)",
        failedToast: "Revolut-Auszahlung fehlgeschlagen oder abgebrochen",
        legalRequired:
          "Rechtliches Profil und IBAN des Empfängers müssen vollständig sein",
        blockedActive:
          "Für diesen Empfänger läuft bereits eine Revolut-Auszahlung",
        error: "Revolut-Auszahlung konnte nicht gestartet werden",
      },
    },
  },
} as const;
